import type React from 'react';

import { Translate, useI18n } from '@change-corgi/core/react/i18n';
import { ButtonLink } from '@change-corgi/design-system-legacy/components/actions';
import { Image } from '@change-corgi/design-system-legacy/components/media';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

import type { LandingPageSlug } from 'src/app/pages/landing/template/pageContext';

type Props = {
	slug: LandingPageSlug;
	onCtaClick: () => void;
};

export const FooterCta: React.FC<Props> = ({ onCtaClick, slug }) => {
	const { translate } = useI18n();

	return (
		<Box p={40}>
			<Box sx={{ display: ['block', 'none'] }}>
				<Image alt="" src={translate(`landing.${slug}.assets.faces_mobile`)} py={32} />
			</Box>
			<Flex sx={{ alignItems: 'center', justifyContent: 'center' }} my={32}>
				<Box sx={{ display: ['none', 'inline'] }}>
					<Image alt="" src={translate(`landing.${slug}.assets.faces_left`)} sx={{ maxWidth: 300 }} p={16} />
				</Box>
				<Box px={[0, 16]} sx={{ flex: 1 }}>
					<Text as="p" size="huge" fontWeight="bold" color="primary-changeRed" sx={{ textAlign: 'center' }} mb={16}>
						<Translate value={`landing.${slug}.footer_cta.title`} />
					</Text>
					<Text as="p" sx={{ textAlign: 'center' }}>
						<Translate value={`landing.${slug}.footer_cta.body`} />
					</Text>
					<Flex sx={{ alignItems: 'center', justifyContent: 'center' }} mt={32}>
						<ButtonLink
							sx={{ width: 300 }}
							onClick={onCtaClick}
							to={`/start-a-petition/intro?source_location=${slug}_landing_page`}
						>
							<Translate value={`landing.${slug}.footer_cta.button`} />
						</ButtonLink>
					</Flex>
				</Box>
				<Box sx={{ display: ['none', 'inline'] }}>
					<Image alt="" src={translate(`landing.${slug}.assets.faces_right`)} sx={{ maxWidth: 300 }} p={16} />
				</Box>
			</Flex>
		</Box>
	);
};
